import $ from 'jquery';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';

document.addEventListener('DOMContentLoaded', function() {
    const servicesCarousel = $('.services-carousel');
    
    if (servicesCarousel.length) {
        servicesCarousel.slick({
            slidesToShow: 5.5,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            autoplay: false,
            prevArrow: '<button type="button" class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3.5,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2.5,
                    }
                }
            ]
        });
    }
}); 